/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var EntityName;

(function (EntityName) {
  EntityName["QUOTE"] = "quote";
  EntityName["VALIDATION"] = "validation";
})(EntityName || (EntityName = {}));